import React, { useRef } from 'react';
import IndustryExpertsHeader from './IndustryExpertsHeader/IndustryExpertsHeader';
import IndustryExpertsDirectory from './IndustryExpertsDirectory/IndustryExpertsDirectory';
import IndustryExpertsNought from './IndustryExpertsNought/IndustryExpertsNought';
import IndustryExpertsJoin from './IndustryExpertsJoin/IndustryExpertsJoin';
import IndustryExpertsBlogs from './IndustryExpertsBlogs/IndustryExpertsBlogs';
import IndustryExpertsFollow from './IndustryExpertsFollow/IndustryExpertsFollow';
import './IndustryExperts.scss';

const IndustryExperts = () => {

  const section1 = useRef(null);
  const section2 = useRef(null);
  const section3 = useRef(null);
 

  const scrollToContent = (content) => {
    switch (content) {
      case 'Find An Expert':
        window.scrollTo({top: section1.current.getBoundingClientRect().top - 150, behavior: 'smooth'});
        break;
      case 'Get Biz Advice':
        window.scrollTo({top: section2.current.getBoundingClientRect().top-120, behavior: 'smooth'});
        break;
      case 'Become an Industry Expert':
        window.scrollTo({top: section3.current.getBoundingClientRect().top-120, behavior: 'smooth'});
        break;
      default:
        break;
    }
  }

  return (
    <div className={`industry-experts-container`}>
      <IndustryExpertsHeader scrollToContent={scrollToContent} />
      <IndustryExpertsNought />
      <IndustryExpertsDirectory ref={section1} />
      <IndustryExpertsJoin ref={section3} />
      <IndustryExpertsBlogs ref={section2} />
      <IndustryExpertsFollow />
    </div>
  )
}

export default IndustryExperts ;